import apiClient from './apiClient';

export type OrarioTipo = 'apertura' | 'appuntamento' | 'telefonico';

export interface OrarioRow {
  id: number;
  ufficio_id: string | null;
  ufficio_nome: string;
  area: string | null;
  location: string | null;
  giorno: string;
  fascia: string;
  tipo: OrarioTipo;
  apertura: string;
  chiusura: string;
  aggiornato_il: string | null;
}

export interface OrariUfficiSyncResult {
  source: string;
  inserted: number;
  updated: number;
  skipped: number;
}

class OrariUfficiService {
  async getAll(): Promise<OrarioRow[]> {
    const res = await apiClient.get<OrarioRow[]>('/api/orari-uffici');
    return res.data;
  }

  async sync(): Promise<OrariUfficiSyncResult> {
    const res = await apiClient.post<OrariUfficiSyncResult>('/api/orari-uffici/sync');
    return res.data;
  }

  async update(id: number, apertura: string, chiusura: string): Promise<OrarioRow> {
    const res = await apiClient.put<OrarioRow>(`/api/orari-uffici/${id}`, { apertura, chiusura });
    return res.data;
  }

  async create(payload: {
    ufficio_nome: string;
    giorno: string;
    fascia: string;
    tipo: OrarioTipo;
    apertura: string;
    chiusura: string;
  }): Promise<OrarioRow> {
    const res = await apiClient.post<OrarioRow>('/api/orari-uffici', payload);
    return res.data;
  }

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/orari-uffici/${id}`);
  }
}

export const orariUfficiService = new OrariUfficiService();
